/**
 * Число на слайде — как в макете: «15 316», «1 215 549».
 *
 * Разделитель — обычный пробел, не неразрывный: во встроенном в PDF шрифте
 * может не оказаться глифа U+00A0, а переносить число всё равно негде.
 */
export function formatSlideNumber(value: number): string {
  const n = Math.round(Number.isFinite(value) ? value : 0);
  const sign = n < 0 ? '-' : '';
  return sign + String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/**
 * Число на экране статистики — ровно как в приложении: «1,215,829».
 * Instagram группирует разряды запятой даже в русском интерфейсе.
 */
export function formatAppNumber(value: number): string {
  const n = Math.round(Number.isFinite(value) ? value : 0);
  const sign = n < 0 ? '-' : '';
  return sign + String(Math.abs(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/** Счётчики под превью в приложении сокращены: «855», «2,3 тыс.», «76 тыс.». */
export function formatCompactNumber(value: number): string {
  const n = Math.round(Number.isFinite(value) ? value : 0);
  if (Math.abs(n) < 1000) return String(n);
  const trim = (v: number) => String(Math.round(v * 10) / 10).replace('.', ',');
  if (Math.abs(n) < 1_000_000) return `${trim(n / 1000)} тыс.`;
  return `${trim(n / 1_000_000)} млн`;
}

/** Среднее время просмотра в плитке: «10 с.», «1 мин. 5 с.» — как в приложении. */
export function formatAppWatchTime(ms: number): string {
  const total = Math.max(0, Math.round((Number.isFinite(ms) ? ms : 0) / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  if (minutes === 0) return `${seconds} с.`;
  return seconds === 0 ? `${minutes} мин.` : `${minutes} мин. ${seconds} с.`;
}
